var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGym(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.298,
    height: 24.299,
    viewBox: "0 0 24.298 24.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.277,19.2a1.942,1.942,0,0,1,0,2.749l-1.714,1.714a1.946,1.946,0,0,1-2.749,0L.641,16.488a1.947,1.947,0,0,1,0-2.749l1.714-1.714a1.942,1.942,0,0,1,2.749,0ZM.93,18.356a.39.39,0,0,0-.6.065,1.928,1.928,0,0,0,.244,2.437L3.444,23.73a1.927,1.927,0,0,0,2.437.245.39.39,0,0,0,.065-.6ZM13.456,8.2a.778.778,0,0,0-1.1,0L8.2,12.353a.778.778,0,0,0,0,1.1L10.849,16.1a.778.778,0,0,0,1.1,0L16.1,11.945a.778.778,0,0,0,0-1.1Zm9.92-2.257a.39.39,0,0,0,.6-.065,1.928,1.928,0,0,0-.246-2.435L20.86.569A1.928,1.928,0,0,0,18.425.323a.39.39,0,0,0-.065.6ZM16.491.638a1.946,1.946,0,0,0-2.749,0L12.027,2.352a1.942,1.942,0,0,0,0,2.749L19.2,12.274a1.942,1.942,0,0,0,2.749,0l1.714-1.714a1.947,1.947,0,0,0,0-2.749Z",
    transform: "translate(-0.003 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.773bb422.svg";
export { ForwardRef as ReactComponent };